import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Icon from '../../components/Icon/Icon'
import BottomNavBar from '../../components/Layout/BottomNavBar'
import { setTopNavbar, clearTopNavbar } from '../../Reducers/actions/navbarActions'
import './NotFound.scss'

const NotFound = ({ label = "Creation Not Found", subtitle = "The creation you're looking for doesn't exist or has been removed." }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setTopNavbar({
            title: "Page Not Found",
            showBackArrow: true
        }))

        return () => {
            dispatch(clearTopNavbar())
        }
    }, [dispatch])

    return (
        <>
            <div className="not-found-wrapper">
                <div className="not-found-container">
                    <div className="not-found-content">
                        <Icon alias={"search"} width={120} height={120} color="#FF3232" />
                        <h1 className="not-found-title">{label}</h1>
                        <p className="not-found-subtitle">{subtitle}</p>

                        <div className="not-found-actions">
                            <button
                                className="btn red-btn btn-lg"
                                onClick={() => navigate('/')}
                            >
                                Continue HYKing
                            </button>
                            <button
                                className="btn red-outline-btn btn-lg"
                                onClick={() => navigate(-1)}
                            >
                                GO BACK
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <BottomNavBar />
        </>
    )
}

export default NotFound